<template>
  <div class="detail-container">
    <!-- <div class="cert-detail-box columns is-multiline is-12"> -->
    <div class="columns is-multiline is-12">
      <div class="column is-6">
        <div class="cert-detail-box">
        
          <div class="cert-title has-text-weight-semibold">
            Building Name:  {{ this.buildingFootprint.attributes.BUILDING_NAME || 'N/A' }}
          </div>
          <div class="cert-number is-size-2">
            Building ID (BIN):  {{ this.detailInfo.structure_id }}
          </div>
          
          <div
            class="cert-address has-text-weight-bold"
          >
            L&I District:  {{ this.$store.state.searchResults.li_district }}
          </div>

          <div
            class="cert-address has-text-weight-bold"
          >
            OPA Account #:  {{ this.$store.state.searchResults.opa_account_num }}
          </div>
          <div
            class="cert-address"
          >
            <!-- :key="item" -->
            <!-- v-for="item in this.$store.state.detailPage.certAddress" -->
            <div class="multi-cell">
              {{ this.buildingFootprint.attributes.ADDRESS }}
            </div>
            <div class="multi-cell">
              Philadelphia, PA {{ this.$store.state.searchResults.zip_code }}-{{ this.$store.state.searchResults.zip_4 }}
            </div>
          </div>
        </div>

        <v-client-table
          class="table-light no-header column is-12"
          :data="footprintTableData"
          :columns="columns"
          :options="options"
        >
        </v-client-table>

      </div>

      <div class="map-surrounder column is-6">
        <div
          id="map"
          class="map map-class"
        >
          <ImageryToggleControl @toggleImagery="toggleImagery">
          </ImageryToggleControl>
        </div>
        <div class="atlas-link">
          <a
            target="_blank"
            :href="'https://atlas.phila.gov/'+encodeURIComponent(this.buildingFootprint.attributes.ADDRESS)+'/li'"
          >
            View larger map in Atlas <i class="fa fa-external-link" aria-hidden="true"></i>
          </a>
        </div>
      </div>
    </div>
    <div class="detail-table-container columns is-multiline is-centered is-12">


      <div 
        class="certs-container column is-12"
      >
        <h3 class="has-text-weight-bold">Building Certifications ({{ buildingCerts.length }})</h3>

        <Accordion 
          :contents="buildingCertsArrayByType"
          class="certs-accordion"
        >
          <div
            class="section-container"
            slot-scope="{ item }"
          >
            <v-client-table
              v-if="item.certs[0].buildingcerttype !== 'Special Hazards Certification'"
              class="table-light no-header"
              :data="getLatestCertData({item})" 
              :columns="columns" 
              :options="options"
            >
            </v-client-table>

            <div
              v-if="item.certs[0].buildingcerttype === 'Special Hazards Certification' || item.certs.length > 1"
              :class="item.certs[0].buildingcerttype === 'Special Hazards Certification'? '':'older-certs-container'"
            >
              <h4 v-if="item.certs[0].buildingcerttype !== 'Special Hazards Certification'">
                Older {{ item.more }}
              </h4>

              <v-client-table 
                :data="getOlderCertData({item})" 
                :columns="columnsHoriz" 
                :options="options"
              >
              </v-client-table>
            </div>
          </div>
        </Accordion>
      </div>

    </div>
  </div>
</template>

<script>

import maplibregl from 'maplibre-gl';
import 'maplibre-gl/dist/maplibre-gl.css';

import Accordion from '@/components/Accordion';
import moment from 'moment';

import { polygon, featureCollection } from '@turf/helpers';
import centroid from '@turf/centroid';
import ImageryToggleControl from '../../../components/ImageryToggleControl.vue';

export default {
  name: 'BuildingCertificationDetail',
  components: {
    Accordion,
    ImageryToggleControl,
  },
  data() {
    return {
      detailInfo: this.$store.state.detailPage,
      localLocation: null,
      buildingPolygon: [],
      columns: ['id', 'name'],
      columnsHoriz: [ 'Building certification number', 'Building certification type', 'Inspection date', 'Inspection result', 'Expiration date', 'Inspection contractor' ],
      options: {
        filterable: false,
        sortable: [],
        highlightMatches: false,
        pagination: {
          show: false,
          virtual: false,
        },
        perPage: 100,
        columnsClasses: {
          id: 'table-id has-text-weight-bold',
          name: 'table-name',
        },
      },
      certMap: {
        'Standpipe Certification': 'standpipe',
        'Fire Alarm Certification': 'fire_alarm',
        'Smoke Control Certification': 'smoke_control',
        'Pier Report': 'pier',
        'Fire Escape Report': 'fire_escape',
        'Private Bridge Report': 'private_bridge',
        'Emergency and Standby Power Systems Certification': 'emer_stdby_pwr',
        'Special Hazards Certification': 'special_hazards',
        'Facade Report': 'facade',
        'Sprinkler Certification': 'sprinkler',
        'Damper Certification': 'damper',
      },
      certTypes: [
        'Standpipe Certification',
        'Fire Alarm Certification',
        'Smoke Control Certification',
        'Pier Report',
        'Fire Escape Report',
        'Private Bridge Report',
        'Emergency and Standby Power Systems Certification',
        'Special Hazards Certification',
        'Facade Report',
        'Sprinkler Certification',
        'Damper Certification',
      ],
      geojsonBuildingSource: null,
      geojsonBuildingFillLayer: {
        'id': 'geojsonParcelFill',
        'type': 'fill',
        'layout': {},
        'paint': {
          'fill-color': '#9e9ac8',
          'fill-opacity': 0.3,
        },
      },
      geojsonBuildingLineLayer: {
        'id': 'geojsonParcelLine',
        'type': 'line',
        'layout': {},
        'paint': {
          'line-color': '#9e9ac8',
          'line-width': 2,
        },
      },
    }
  },
  mounted() {
    let geojson = this.calculatePolygon();
    const map = new maplibregl.Map({
      container: 'map',
      style: this.$config.map.mbStyle,
      center: this.$store.state.map.center,
      zoom: this.$store.state.map.zoom,
      minZoom: 6,
      maxZoom: 22,
      attributionControl: false,
    });

    map.on('load', () => {
      this.$store.state.map.map = map;
      let canvas = document.querySelector(".maplibregl-canvas");
      canvas.setAttribute('tabindex', -1);
      map.getSource('liBuildingFootprints').setData(geojson);
    })
  },
  destroyed() {
    this.$store.commit('closeDetail');
  },
  computed: {
    buildingFootprint() {
      // console.log('buildingFootprint computed, this.$store.state.buildingFootprints[0].attributes.BIN:', this.$store.state.buildingFootprints[0].attributes.BIN, 'this.$attrs.query.Id:', this.$attrs.query.Id);
      let id = this.$attrs.query.Id;
      let value = this.$store.state.buildingFootprints.filter(function(item) {
        // console.log('in buildingFootprint filter item:', item, 'item.attributes.BIN:', item.attributes.BIN, 'id:', id);
        return item.attributes.BIN == id;
      })[0];
      // console.log('buildingFootprint computed value:', value);
      return value;
    },
    buildingCerts() {
      // console.log('buildingCerts computed, this.$store.state.buildingCerts:', this.$store.state.buildingCerts);
      let id = this.$attrs.query.Id;
      let value = this.$store.state.buildingCerts.filter(function(item) {
        // console.log('in buildingCerts filter item:', item);
        return item.bin == id;
      });
      return value;
    },
    buildingCertSummary() {
      let id = this.$attrs.query.Id;
      let value = this.$store.state.buildingCertificationSummary.filter(function(item) {
        // console.log('in buildingCerts filter item:', item);
        return item.structure_id == id;
      })[0];
      return value;
    },
    buildingCertsArrayByType() {
      let certsByType = [];
      for (let certType of Object.entries(this.certMap)) {
        // console.log('in buildingCertsArrayByType loop, certType:', certType, this.buildingCertSummary);
        let value = this.buildingCerts.filter(function(item) {
          return item.buildingcerttype == certType[0];
        });
        if (value.length) {
          if (certType[0] !== 'Special Hazards Certification') {
            certsByType.push({
              title: certType[0] + ' (' + value.length + ') - ' + this.buildingCertSummary[certType[1]+'_status'],
              certs: value,
              more: certType[0] + 's',
            });
          } else {
            certsByType.push({
              title: certType[0] + ' (' + value.length + ')',
              certs: value,
              more: certType[0] + 's',
            });
          }
        }
      }
      return certsByType;
    },

    footprintTableData(){
      // the conversion value of 6.3225 was calculated to make the footprint area in sq ft work
      let value = this.buildingFootprint.attributes.Shape__Area * 6.3225;
      let tableInfo = [
        {
          id: "Building name",
          name: this.buildingFootprint.attributes.BUILDING_NAME || 'N/A',
        },
        {
          id: "Building ID",
          name: this.detailInfo.structure_id,
        },
        {
          id: "Building height (approx)",
          name: this.buildingFootprint.attributes.APPROX_HGT + ' ft',
        },
        {
          id: "Building footprint (approx)",
          name: Math.round(value) + ' sq ft',
        },
      ]
      return tableInfo;
    },
  },
  methods: {
    configForBasemap(basemap) {
      return this.$config.map.basemaps[basemap] || {};
    },
    calculatePolygon() {
      // console.log('calculatePolygon is running');
      let footprint = this.$store.state.buildingFootprints.filter(function(item) {
        return item.attributes.BIN == this.detailInfo.structure_id;
      }.bind(this))[0];
      
      let buildingPolygon = [];
      let buildingPolygon2 = [];
      for (let i = 0; i < footprint.geometry.rings.length; i++) {
        buildingPolygon.push([]);
        buildingPolygon2.push([]);
        let ring = footprint.geometry.rings[i];
        for (let vertex of ring) {
          buildingPolygon[i].push([vertex[1], vertex[0]]);
          buildingPolygon2[i].push([vertex[0], vertex[1]]);
        }
      }
      this.buildingPolygon = buildingPolygon;

      let turfPolygon = polygon(buildingPolygon);
      let buildingCentroid = centroid(turfPolygon);
      this.$store.commit('setMapCenter', [ buildingCentroid.geometry.coordinates[1], buildingCentroid.geometry.coordinates[0] ]);

      let turfPolygon2 = polygon(buildingPolygon2);
      let features = [turfPolygon2]
      let geojson = featureCollection(features);
      return geojson;
      // console.log('geojson:', geojson, 'turfPolygon:', turfPolygon, 'buildingCentroid:', buildingCentroid, 'buildingPolygon:', buildingPolygon, 'map:', map, "map.getSource('liBuildingFootprints'):", map.getSource('liBuildingFootprints'));
      // console.log('calculatePolygon is running, buildingCentroid:', buildingCentroid, 'turfPolygon:', turfPolygon, 'buildingPolygon:', buildingPolygon, 'footprint.geometry:', footprint.geometry, 'this.$store.state.buildingFootprints:', this.$store.state.buildingFootprints, 'this.detailInfo.latlng:', this.detailInfo.latlng);
    },
    clickBackButton(){
      this.$store.commit('closeDetail');
    },
    getLatestCertData({ item }) {
      let certs = [...item.certs];
      certs.sort((a, b) => {
        // return new Date(b.expirationdate) - new Date(a.expirationdate);
        return new Date(b.inspectiondate) - new Date(a.inspectiondate);
      });
      // console.log('getLatestCertData certs:', certs, 'item.certs:', item.certs, 'item.certs[0]:', item.certs[0]);
      const constItem = certs[0];
      let tableData = [];
      const idList = [ 'buildingcertnumber', 'buildingcerttype', 'inspectiondate', 'inspectionresult', 'expirationdate', 'contractorname', 'casefile' ];
      const idMap = {
        'buildingcertnumber': 'Building certification number',
        'buildingcerttype': 'Building certification type',
        'inspectiondate': 'Inspection date',
        'inspectionresult': 'Inspection result',
        'expirationdate': 'Expiration date',
        'contractorname': 'Inspection contractor',
        'casefile': 'Case file',
      }
      idList.forEach(each => {
        // console.log(each);
        let row = new Object();
        row.id = idMap[each];
        if (each == 'expirationdate' || each == 'inspectiondate') {
          if (constItem[each] != null) {
            row.name = moment(constItem[each]).format('MM-DD-yyyy');
          } else {
            row.name = 'No date';
          }
        } else if (each == 'casefile') {
          const type = constItem.buildingcerttype;
          // console.log('in forEach, this.buildingCertSummary:', this.buildingCertSummary, 'type:', type);
          row.name = this.buildingCertSummary[this.certMap[type]+'_casefile'];
        } else {
          row.name = constItem[each];
        }
        tableData.push(row);
      });
      // console.log('getLatestCertData, tableData:', tableData);
      return tableData;
    },
    getOlderCertData({ item }) {
      let certs = [...item.certs];
      certs.sort((a, b) => {
        // return new Date(b.expirationdate) - new Date(a.expirationdate);
        return new Date(b.inspectiondate) - new Date(a.inspectiondate);
      });
      if (certs[0].buildingcerttype !== 'Special Hazards Certification') {
        certs.shift();
      }
      // console.log('getOlderCertData certs:', certs, 'item.certs:', item.certs);//, 'constItem:', constItem);
      let tableData = [];
      certs.forEach( eachConstItem => {
        // console.log('getOlderCertData, constItem:', eachConstItem);
        let row = new Object();
        row['Building certification number'] = eachConstItem.buildingcertnumber;
        row['Building certification type'] = eachConstItem.buildingcerttype;
        row['Inspection date'] = moment(eachConstItem.inspectiondate).format('MM-DD-yyyy');
        row['Inspection result'] = eachConstItem.inspectionresult;
        row['Expiration date'] = moment(eachConstItem.expirationdate).format('MM-DD-yyyy');
        row['Inspection contractor'] = eachConstItem.contractorname;
        tableData.push(row);
      });
      // console.log('getOlderCertData, tableData:', tableData);
      return tableData;
    },
    toggleImagery() {
      const map = this.$store.state.map.map;
      if (!this.$store.state.map.imageryOn) {
        this.$store.state.map.imageryOn = true;
        map.addLayer(this.$config.map.mapLayers['2023'], 'liBuildingFootprints');
        map.addLayer(this.$config.map.mapLayers.imageryLabels, 'liBuildingFootprints');
        map.addLayer(this.$config.map.mapLayers.imageryParcelOutlines, 'liBuildingFootprints');
      } else {
        this.$store.state.map.imageryOn = false;
        map.removeLayer('2023');
        map.removeLayer('imageryLabels');
        map.removeLayer('imageryParcelOutlines')
      }
    },
  },
}
</script>

<style lang="scss">
  
#map-container {
  height: 100%;
}

.button-control {
  margin-right: 10px !important;
  margin-left: 10px !important;
}

.maplibregl-ctrl {
  margin-left: 10px !important;
}

.map-holder {
  height: 100%;
}

.atlas-link {
  // margin-top: 300px;
  text-align: right;
}

.older-certs-container {
  margin-top: 2rem;
}

.section-container {
  margin-bottom: 2rem;
}

.columns:last-child {
  margin-bottom: .75rem !important;
}

.detail-container {
  margin-top: 4rem;
  background-color: white;
  margin: auto;
}

.detail-button {
  margin-top: 20px;
}

.no-header th {
  display: none !important;
}

//  CSS for grey header-box in cert detail page
.detail-container .cert-detail-box {
  background-color: $ben-franklin-blue-light;
  margin: 0;
  padding: 15px 5px 15px 25px;
  clear: both;
  & .column {
    padding: 0;
  }
  .cert-title {
    text-transform: uppercase;
  }
  .cert-number {
    text-transform: uppercase;
    padding: 5px 0 15px 0;
  }
}

.cert-detail-innerbox {
  background-color: $ben-franklin-blue-light;
}

.table-id.has-text-weight-bold {
  width: 35%;
}

div.is-pulled-right.VueTables__limit {
   display: none;
}

.extra-row-padding {
  padding-bottom: 1rem;
}

// CSS for the Zoning Cell elements from scoped-slot
.zoning-border {
  &:not(:last-child){
    border-bottom: 1px black solid;
    padding-bottom: 10px;
  }
  width: 100%;
  height: 100%;
  clear: both;
  margin: 5px 0;
  display: flow-root;
  position: relative;
  .zoning-left {
    width: 50%;
    float: left;
    display: block;
  }
  .zoning-right {
    position: absolute;
    padding: 10px;
    right: 0;
  }
  .zoning-bottom {
    font-size: small;
    display: flex;
    .zoning-small {
      display: inline-grid;
      flex-grow: 1;
    }
  }
}

.certs-container {
  padding-bottom: 0px;
}

.certs-container td, th {
  background-color: #f0f0f0;
}

.certs-accordion {
  margin-bottom: 0px !important;
}

.certs-accordion-container, .zba-accordion-container {
  margin-top: 35px;
  margin: auto;
}

.certs-accordion>div.accordion-question {
  padding: 0 15px;
  background: $ghost-grey;
  border-bottom: none;
  border-spacing: 0 14px;
  border-collapse: separate;
} 

.certs-accordion .table-light {
  th, tr, td {
    background: $ghost-grey;
  }
}

.accordion-question {
  margin-bottom: 25px;
}

.certs-accordion .accordion-question .accordion-content .contents-div {
  width: 100%;
}

.appeals.table-id.has-text-weight-bold {
  text-transform: capitalize;
}

.map-class {
  height: 100%;
}

</style>